import "slick-carousel";

let slickCarouselInit = function (slickEl, slickOptions) {

    const defaultOptions = {
        dots: true,
        arrows: true,
        prevArrow: '<button type="button" class="slick-prev"><span><i class="icon icon-arrow-slider-left"></i></span></button>',
        nextArrow: '<button type="button" class="slick-next"><span><i class="icon icon-arrow-slider-right"></i></span></button>',
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: false,
        autoplay: false,
        autoplaySpeed: 3000,
    };

    let newSlickOptions = Object.assign({}, defaultOptions, slickOptions);

    slickEl.slick(newSlickOptions);

};

$(document).ready(function () {

    $('.js__home-hero--slider').each(function () {
        slickCarouselInit($(this), {
            adaptiveHeight: true,
            arrows: true,
            dots: true,
            autoplay: true,
            responsive: [
                {
                    breakpoint: 960,
                    settings: {
                        arrows: false,
                    }
                },
            ]
        })
    });

});

export default slickCarouselInit;
